module.exports = __webpack_public_path__ + "static/media/instructor-banner-icon.8f229c3c.svg";